import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { Url } from "../../config/config";
import Modal from "react-bootstrap/Modal";
import Pagination from "react-js-pagination";
import useButtonLoader from "../../hooks/useButtonLoader";
import useFullPageLoader from "../../hooks/useFullPageLoader";

export default function DocumentVerification() {
  const [inputField, setInputField] = useState({
    status: true,
    id: "",
    documentName: "",
    docsType: "",
    description: "",
  });

  const [errorField, setErrorField] = useState({
    documentName: "",
    docsType: "",
    description: "",
  });
  const [activePage, setActivePage] = useState(1);
  const [search, setSearch] = useState("");
  const [BlockModal, setBlockModal] = useState(false);
  const [AddModal, setAddModal] = useState(false);
  const [document, setDocument] = useState([]);
  const [total_count, setTotal] = useState(0);
  const [submitButtonElement, setSubmitLoading] = useButtonLoader(
    "Submit",
    "Please wait..."
  );
  const [loader, showLoader, hideLoader] = useFullPageLoader();

  //******Handel delete**************** */
  const [DeleteModal, setDeleteModal] = useState(false);

  const handleDeleteClose = () => {
    setDeleteModal(false);
  };
  const handelDeleteShow = (id) => {
    setDeleteModal(true);
    setInputField({ ...inputField, id: id });
  };

  const handelDelete = async () => {
    try {
      const res = await axios({
        url: `${Url}/deleteDocs?docsId=${inputField.id}`,
        method: "DELETE",
      });
      if (res.data.status === 200) {
        handleDeleteClose();
        toast.success(res.data.message);
        documentList(activePage);
      } else {
        toast.error("Something went to wrong");
      }
    } catch (err) {
      console.log(err);
    }
  };
  //*********Handel document list************//
  const documentList = async (page, search = "") => {
    try {
      showLoader();
      const res = await axios({
        url: `${Url}/documentList?page=${page}&search=${search}`,
        method: "GET",
      });
      hideLoader();
      if (res.data.status === 200) {
        setDocument(res.data.data.user);
        setTotal(res.data.data.total);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    documentList(1);
  }, []);

  //********Handel update status************** */

  const handleChecked = (e, id) => {
    handelBlockShow();
    setInputField({
      ...inputField,
      status: e.target.checked,
      id: id,
    });
  };

  const handleBlockClose = () => {
    setBlockModal(false);
  };
  const handelBlockShow = () => {
    setBlockModal(true);
  };

  const updateStatus = async () => {
    try {
      const res = await axios({
        url: `${Url}/documentStatus`,
        method: "POST",
        data: {
          docsId: inputField.id,
          status: inputField.status,
        },
      });
      console.log(res.data.status);
      if (res.data.status === 200) {
        handleBlockClose();
        toast.success(res.data.message);
        documentList(activePage);
      } else {
        toast.error("Something went to wrong");
      }
    } catch (err) {
      console.log(err);
    }
  };

  //************handel input onchnage value********** */
  const handleInputChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputField({
      ...inputField,
      [name]: value,
    });
  };

  //*********Handel input validation ***********/
  const handleValidation = () => {
    let errorField = {};
    let formIsValid = true;
    if (!inputField.documentName) {
      errorField["documentName"] = "Document name field is required";
      formIsValid = false;
    }

    if (!inputField.docsType) {
      errorField["docsType"] = "Document type field is required";
      formIsValid = false;
    }

    if (!inputField.description) {
      errorField["description"] = "Description field is required";
      formIsValid = false;
    }
    setErrorField(errorField);
    return formIsValid;
  };

  const clearState = () => {
    setInputField({
      ...inputField,
      documentName: "",
      docsType: "",
      description: "",
    });
    setErrorField({
      ...errorField,
      documentName: "",
      docsType: "",
      description: "",
    });
  };
  //*********Handel submit form *********/
  const handleShow = () => {
    setAddModal(true);
  };

  const handleClose = () => {
    setAddModal(false);
  };

  const handelSubmit = async (e) => {
    try {
      if (handleValidation()) {
        e.preventDefault();
        setSubmitLoading(true);
        const res = await axios({
          url: `${Url}/adddocs`,
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          data: {
            documentName: inputField.documentName,
            docsType: inputField.docsType,
            description: inputField.description,
            status: true,
          },
        });
        setSubmitLoading(false);
        if (res.data.status === 200) {
          clearState();
          handleClose();
          toast.success(res.data.message);
          documentList(activePage);
        } else if (res.data.status === 401) {
          toast.error("Document name is already exists");
        } else {
          toast.error("Something went to wrong");
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  //*********Handel pagination*********** */
  const handlePageChange = (pageNo) => {
    console.log(pageNo);
    setActivePage(pageNo);
    documentList(pageNo);
  };

  const handelSearch = (e) => {
    setSearch(e.target.value);
    console.log(activePage);
    documentList(activePage, e.target.value);
    //console.log(e.target.value);
  };

  var count = ((activePage - 1) * 10 + 1);

  return (
    <React.Fragment>
      <title>Documents Management</title>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="SearchBox">
              <input
                type="text"
                placeholder="Search .."
                onChange={handelSearch}
              />
              {/* <button>Apply</button> */}

              <button className="button py-auto" type="button" onClick={handleShow}>
                Add&nbsp;Document
              </button>
            </div>
            <h4 className="Title">
              Documents Management
              {/* <Link to="/category/add">Add New Document</Link> */}
            </h4>

            <div className="TableList">
              {loader}
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Document Name</th>
                    <th>Document Type</th>
                    <th>Document Description</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {document &&
                    document.length > 0 &&
                    document.map((item, i) => (
                      <tr key={i}>
                        <td>{count++}</td>
                        <td>{item.documentName}</td>
                        <td>{item.docsType}</td>
                        <td>{item.description}</td>

                        <td>
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="status"
                              checked={item.status}
                              onChange={(e) => handleChecked(e, item._id)}
                            />
                            <label className="form-check-label"></label>
                          </div>
                        </td>

                        <td>
                          <span
                            className="Red"
                            onClick={(e) => handelDeleteShow(item._id)}
                          >
                            <i className="fa fa-trash"></i>
                          </span>
                        </td>

                        {/* <td>
                        <span
                          className={item.status == false ? "orange" : "green"}
                          onClick={() => {
                            const confirmBox = window.confirm(
                              "Are you sure want to confirm change the status " +
                                item.name
                            );
                            if (confirmBox === true) {
                              updateStatus(
                                item._id,
                                item.status == true ? false : true
                              );
                            }
                          }}
                        >
                          {item.status == true ? "Active" : "Inactive"}
                        </span>
                      </td>
                      <td>
                        <span
                          className="Red"
                          onClick={() => {
                            const confirmBox = window.confirm(
                              "Are you really want to remove this category " +
                                item.name
                            );
                            if (confirmBox === true) {
                              handelDelete(item._id);
                            }
                          }}
                        >
                          <i className="fa fa-trash"></i>
                        </span>
                        <Link
                          className="Green"
                          to={`/category/edit/${item._id}`}
                          data-toggle="modal"
                          data-target="#EditModal"
                        >
                          <i className="fa fa-pencil-square-o"></i>
                        </Link>
                      </td> */}
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            {total_count > 10 ? (
              <div className="Pagination">
                <Pagination
                  activePage={activePage}
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  itemsCountPerPage={10}
                  totalItemsCount={total_count}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <div className="ModalBox">
        {/* block or unblock model */}
        <Modal
          show={BlockModal}
          
          onHide={handleBlockClose}
        >
          <Modal.Header closeButton onClick={handleBlockClose}>
            <Modal.Title>Change Status</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure want to change the status?</Modal.Body>
          <Modal.Footer>
            <button className="secondary" variant="secondary" onClick={handleBlockClose}>
              No
            </button>
            <button className="primary" variant="primary" onClick={updateStatus}>
              Yes
            </button>
          </Modal.Footer>
        </Modal>
        {/* end block unblock modal */}

        {/* start delete modal */}
        <Modal
          show={DeleteModal}
          
          onHide={handleDeleteClose}
        >
          <Modal.Header closeButton onClick={handleDeleteClose}>
            <Modal.Title>Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure want to delete this document?</Modal.Body>
          <Modal.Footer>
            <button className="secondary" variant="secondary" onClick={handleDeleteClose}>
              No
            </button>
            <button className="primary" variant="primary" onClick={handelDelete}>
              Yes
            </button>
          </Modal.Footer>
        </Modal>

        {/* end delete modal */}

        {/* Add document model */}
        <Modal show={AddModal} style={{ opacity: 1 }} onHide={handleClose}>
          <Modal.Header closeButton onClick={handleClose}>
            <Modal.Title>Add New Document</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form method="POST">
              <div className="form-group">
                <label>Document Name </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Document Name"
                  name="documentName"
                  value={inputField.documentName}
                  onChange={handleInputChange}
                />
                <span style={{ color: "red" }} className="error">
                  {errorField.documentName}
                </span>
              </div>
              <div className="form-group mt-3">
                <label>Select Document Type </label>
                <select
                  className="form-control"
                  name="docsType"
                  value={inputField.docsType}
                  onChange={handleInputChange}
                >
                  <option>Select Document Type</option>
                  <option value="pdf">PDF</option>
                  <option value="png">PNG</option>
                  <option value="jpeg">JPEG</option>
                </select>
                <span style={{ color: "red" }} className="error">
                  {errorField.docsType}
                </span>
              </div>
              <div className="form-group mt-3">
                <label>Description </label>
                <textarea
                  className="form-control"
                  name="description"
                  value={inputField.description}
                  onChange={handleInputChange}
                ></textarea>
                <span style={{ color: "red" }} className="error">
                  {errorField.description}
                </span>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <button variant="secondary" onClick={handleClose}>
              Close
            </button>
            <button
              type="button"
              onClick={handelSubmit}
              ref={submitButtonElement}
            >
              Submit
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    </React.Fragment>
  );
}
